import { getProjects } from '@/api/projects'

const state = () => ({
  visitors: [],
  visitorPagination: {
    size: 25,
    currentPage: 1,
    total: 25
  },
  sale_associates: [],
  saleAssociatePagination: {
    size: 25,
    currentPage: 1,
    total: 25
  },
  projects: [],
  project: null,
  profilePluginConfig: null,
  profilePluginInfo: null,
  privateTourPluginInfo: null,
  blendingList: [
    { name: 'No blending', value: 'NOBLEND' },
    { name: 'Simple crossblending', value: 'BLEND(1.0, easeInCubic)' },
    { name: 'Zoom blend', value: 'ZOOMBLEND(2.0, 2.0, easeInOutSine)' },
    { name: 'Black-out', value: 'COLORBLEND(2.0, 0x000000, easeOutSine)' },
    { name: 'White-flash', value: 'LIGHTBLEND(1.0, 0xFFFFFF, 2.0, linear)' },
    { name: 'Right-to-left', value: 'SLIDEBLEND(1.0, 0.0, 0.2, linear)' },
    { name: 'Top-to-bottom', value: 'SLIDEBLEND(1.0, 90.0, 0.01, linear)' },
    { name: 'Diagonal', value: 'SLIDEBLEND(1.0, 135.0, 0.4, linear)' },
    { name: 'Circle open', value: 'OPENBLEND(1.0, 0.0, 0.2, 0.0, linear)' },
    { name: 'Vertical open', value: 'OPENBLEND(0.7, 1.0, 0.1, 0.0, linear)' },
    { name: 'Horizontal open', value: 'OPENBLEND(1.0, -1.0, 0.3, 0.0, linear)' },
    { name: 'Elliptic + Zoom', value: 'OPENBLEND(1.0, -0.5, 0.3, 0.8, linear)' }
  ]
})

const mutations = {
  SET_VISITORS: (state, data) => {
    state.visitors = data
  },
  SET_VISITOR_PAGINATION: (state, data) => {
    state.visitorPagination = data
  },
  ADD_VISITOR: (state, visitor) => {
    state.visitors.unshift(visitor)
  },
  UPDATE_VISITOR: (state, visitor) => {
    let index = state.visitors.findIndex(item => item.id === visitor.id)
    if (index !== -1) {
      state.visitors.splice(index, 1, visitor)
    }
  },
  REMOVE_VISITOR: (state, visitor) => {
    let index = state.visitors.findIndex(item => item.id === visitor.id)
    if (index !== -1) {
      state.visitors.splice(index, 1)
    }
  },
  SET_SALE_ASSOCIATES: (state, data) => {
    state.sale_associates = data
  },
  SET_SALE_ASSOCIATE_PAGINATION: (state, data) => {
    state.saleAssociatePagination = data
  },
  ADD_SALE_ASSOCIATE: (state, saler) => {
    state.sale_associates.unshift(saler)
  },
  UPDATE_SALE_ASSOCIATE: (state, saler) => {
    let index = state.sale_associates.findIndex(item => item.id === saler.id)
    if (index !== -1) {
      state.sale_associates.splice(index, 1, saler)
    }
  },
  REMOVE_SALE_ASSOCIATE: (state, saler) => {
    let index = state.sale_associates.findIndex(item => item.id === saler.id)
    if (index !== -1) {
      state.sale_associates.splice(index, 1)
    }
  },
  SET_PROJECTS: (state, data) => {
    state.projects = data
  },
  SET_PROJECT: (state, data) => {
    state.project = data
  },
  SET_PROFILE_PLUGIN_CONFIG: (state, data) => {
    state.profilePluginConfig = data
  },
  SET_PROFILE_PLUGIN_INFO: (state, data) => {
    state.profilePluginInfo = data
  },
  SET_PRIVATE_PLUGIN_INFO: (state, data) => {
    state.privateTourPluginInfo = data
  },
  REPLACE_HOTSPOT: (state, data) => {
    let scene = state.project.scenes.find((s) => s.hotspots.map((h) => h.id).includes(data.id))
    if (scene) {
      /** Replace hotspot if it's exist */
      const hotspotIndex = scene.hotspots.findIndex((h) => h.id === data.id)
      if (hotspotIndex !== -1) {
        console.log('UPDATE HOTSPOT', hotspotIndex)
        scene.hotspots.splice(hotspotIndex, 1, data)
        console.log('scene.hotspots', scene.hotspots[hotspotIndex])
      }
    } else {
      /** Add new hotspot */
      let scene = state.project.scenes.find((s) => s.id === data.scene_id)
      if (scene) {
        scene.hotspots.push(data)
      }
    }
  },
  SET_HOTSPOT_KEY: (state, data) => {
    const { id, key, value } = data
    const scene = state.project.scenes.find((s) => s.hotspots.map((h) => h.id).includes(id))
    if (!scene) return
    const hotspot = scene.hotspots.find((h) => h.id === id)
    if (hotspot) {
      hotspot[key] = value
    }
  }
}

const actions = {
  setVisitors ({ commit }, data) {
    commit('SET_VISITORS', data)
  },
  setVisitorPagination ({ commit }, data) {
    commit('SET_VISITOR_PAGINATION', data)
  },
  addVisitor ({ commit }, data) {
    commit('ADD_VISITOR', data)
  },
  updateVisitor ({ commit }, data) {
    commit('UPDATE_VISITOR', data)
  },
  removeVisitor ({ commit }, data) {
    commit('REMOVE_VISITOR', data)
  },
  setSaleAssociates ({ commit }, data) {
    commit('SET_SALE_ASSOCIATES', data)
  },
  setSaleAssociatePagination ({ commit }, data) {
    commit('SET_SALE_ASSOCIATE_PAGINATION', data)
  },
  addSaleAssociate ({ commit }, data) {
    commit('ADD_SALE_ASSOCIATE', data)
  },
  updateSaleAssociate ({ commit }, data) {
    commit('UPDATE_SALE_ASSOCIATE', data)
  },
  removeSaleAssociate ({ commit }, data) {
    commit('REMOVE_SALE_ASSOCIATE', data)
  },
  fetchProjects ({commit}) {
    return new Promise((resolve, reject) => {
      getProjects({limit: 10, pagination: 0}).then(res => {
        if (res.status === 1) {
          commit('SET_PROJECTS', res.data)
          resolve(res.data)
        }
      })
        .catch(error => reject(error))
    })
  },
  setProject ({commit}, data) {
    commit('SET_PROJECT', data)
  },
  setProfilePluginConfig ({commit}, data) {
    commit('SET_PROFILE_PLUGIN_CONFIG', data)
  },
  setProfilePluginInfo ({commit}, data) {
    commit('SET_PROFILE_PLUGIN_INFO', data)
  },
  setPrivateTourPluginInfo ({commit}, data) {
    commit('SET_PRIVATE_PLUGIN_INFO', data)
  }
}

const getters = {
  visitors (state) {
    return state.visitors
  },
  visitorPagination (state) {
    return state.visitorPagination
  },
  saleAssociatePagination (state) {
    return state.saleAssociatePagination
  },
  saleAssociates (state) {
    return state.sale_associates
  },
  projects (state) {
    return state.projects
  },
  project (state) {
    return state.project
  },
  profilePluginConfig (state) {
    return state.profilePluginConfig
  },
  profilePluginInfo (state) {
    return state.profilePluginInfo
  },
  privateTourPluginInfo (state) {
    return state.privateTourPluginInfo
  },
  blendingList (state) {
    return state.blendingList
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/components/project/store/index.js